/**
 * Pure keyboard-navigation arithmetic for `SlotMap`.
 *
 * Kept out of the component deliberately: vitest here runs in a node
 * environment and only matches `src/**\/*.test.ts`, so logic living in the
 * `.tsx` file would never be covered by a test.
 */

export interface GridPosition {
  row: number
  column: number
}

export interface GridSize {
  rows: number
  columns: number
}

export type ArrowKey = 'ArrowUp' | 'ArrowDown' | 'ArrowLeft' | 'ArrowRight'

/**
 * The next roving-focus position for an arrow key, 1-based and clamped at
 * the grid's edges — there is no wrap, so pressing further into an edge just
 * holds focus where it already is rather than jumping to the opposite side.
 */
export function nextCell(pos: GridPosition, key: ArrowKey, size: GridSize): GridPosition {
  switch (key) {
    case 'ArrowUp':
      return { row: Math.max(1, pos.row - 1), column: pos.column }
    case 'ArrowDown':
      return { row: Math.min(size.rows, pos.row + 1), column: pos.column }
    case 'ArrowLeft':
      return { row: pos.row, column: Math.max(1, pos.column - 1) }
    case 'ArrowRight':
      return { row: pos.row, column: Math.min(size.columns, pos.column + 1) }
  }
}
